import { render } from "./WCSideMenuItemV2.vue?vue&type=template&id=c7453f66&scoped=true"
import script from "./WCSideMenuItemV2.vue?vue&type=script&lang=js"
export * from "./WCSideMenuItemV2.vue?vue&type=script&lang=js"

import "./WCSideMenuItemV2.vue?vue&type=style&index=0&id=c7453f66&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7453f66"]])

export default __exports__